<!-- Products -->
<template>
  <div class="Products">
    <div class="wai2">
      <div class="sectiontu">
        <div class="sectiontu1">
          <h2>智选云商分销版</h2>
          <p class="p1">融合“b端订货商城+进销存+CRM+仓储管理”的B2B业务协作平台</p>
          <p class="p2">帮助企业有效获客，增收降本，加速资金流转。</p>
          <button @click="xianshi">免费试用</button>
        </div>
        <!-- <img src="../assets/image/banner3.png" alt /> -->
      </div>
      <div class="sectioncp">
        <h2>产品结构</h2>
        <div>
          <img src="../assets/image/fenxiaojiegou1.png" alt />
        </div>
      </div>
      <div class="sectioncp2">
        <h2>商品管理</h2>
        <p>畅销商品搭售滞销商品，轻松去库存，减少资金占用</p>
        <div>
          <img src="../assets/image/shangpinguanli.png" alt />
        </div>
      </div>
      <div class="sectiontab">
        <h2>客户管理</h2>
        <div class="tablan">
          <div class="tablan2">
            <a>
              <span :class="tabe==1?'active':''" @click="tabe=1">额度账期</span>
            </a>
            <a>
              <span :class="tabe==2?'active':''" @click="tabe=2">预付款</span>
            </a>
            <a>
              <span :class="tabe==3?'active':''" @click="tabe=3">客户对账单</span>
            </a>
          </div>
        </div>
        <div class="tablan1" v-if="tabe==1">
          <img src="../assets/image/eduzhangqi.png" alt />
        </div>
        <div class="tablan2" v-if="tabe==2">
          <img src="../assets/image/yufukuan.png" alt />
        </div>
        <div class="tablan3" v-if="tabe==3">
          <img src="../assets/image/duizhangdan.png" alt />
        </div>
      </div>
      <div class="sectionguanli">
        <h2>渠道管理</h2>
        <p>强大的渠道管理工具，助力商家实现渠道策略</p>
        <div class="dav1">
          <img src="../assets/image/qudao1.png" alt />
        </div>
        <div class="dav2" style="margin-top: 55px;">
          <img src="../assets/image/qudao2.png" alt />
        </div>
      </div>
      <div class="sectionj">
        <div class="sectionjy">
          <h2>交易管理</h2>
          <p>多种支付方式灵活配置，满足各种支付场景，让交易更顺畅，提高客户体验</p>
          <div>
            <img src="../assets/image/jiaoyiguanli.png" alt />
          </div>
        </div>
      </div>
      <div class="sectionyx">
        <h2>营销管理</h2>
        <p>跨平台、多终端，客户随时随地快速订货</p>
        <div>
          <img src="../assets/image/yingxiaoguanli.png" alt />
        </div>
      </div>
    </div>
   <transition :appear="true">
      <div class="tanchu" v-if="xianshia">
        <h3>
          申请试用
          <i @click="xianshia=false" class="glyphicon glyphicon-remove" aria-hidden="true"></i>
        </h3>
        <form @submit.prevent="saveProduct(xinxi)">
          <!-- <form action="https://adminapiv2.zolerp.cn//api/Examine/IntentionalCustomerAdd" method="post"> -->
          <span class="span1">*</span>
          <input
            id="uesrname"
            type="text"
            placeholder="您的姓名"
            v-model="xinxi.Contacts"
            required
            maxlength="15"
          />
          <span class="a1 span1">*</span>
          <input
            id="tele"
            type="text"
            placeholder="您的手机"
            v-model="xinxi.Phone"
            required
            pattern="^1\d{10}$"
            maxlength="11"
          />
          <span class="a2 span1">*</span>
          <input
            id="confirmCode"
            class="yabzeng"
            type="text"
            placeholder="手机验证码"
            v-model="xinxi.VerificationCcode"
            required
            maxlength="6"
          />
          <span v-if="xinxi.Phone.length==11">
            <input
              type="button"
              class="huqv"
              value="获取验证码"
              @click="huoqu(xinxi.Phone)"
              v-if="daojis"
            />
            <input
              type="button"
              class="huqv"
              style="background-color: #666666;"
              :value="count"
              v-else
            />
          </span>
          <span v-else>
            <input type="button" class="huqv" style="background-color: #666666;" value="获取验证码" />
          </span>
          <span class="a3 span1">*</span>
          <input
            id="province"
            type="text"
            placeholder="您的省份"
            v-model="xinxi.Address"
            required
            maxlength="20"
          />
          <span class="a4 span1">*</span>
          <input
            id="company"
            type="text"
            placeholder="您的公司名称"
            v-model="xinxi.CorporateName"
            required
            maxlength="20"
          />
          <p style="color: red; font-size: 10px;padding-left: 25px; margin-top: 5px;">{{cashou}}</p>
          <button>提交</button>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import axios from "axios";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      lista: 1,
      tabe: 1,
      xianshia: false,
      TempToken:"",
      xinxi: {
        CorporateName: "",
        Phone: "",
        Address: "",
        Contacts: "",
        VerificationCcode: "",
      },
      UserName: "",
      tempToken: "",
      token: "",
      cashou: "",
      daojis:true,
      show: true,
      count: '',
      timer: null,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
 
  methods: {
    // tijiao() {
    //   console.log(this.xinxi);
    // },
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.daojis = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.daojis = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    huoqu(e){
      // console.log(this.xinxi.Phone.length);
      // console.log(e.length);
      if(this.xinxi.Phone.length == 11){
        // console.log('发送');
        let a = `Phone=${e}`
        
        axios.post('https://adminapiv2.zolerp.cn//api/Examine/GetSendRegisterToken',a).then(response => {        
          // console.log( response.data.Data)
          let data = response.data.Data
          this.cashou=response.data.Message
          this.fashong(data.token,data.tempToken,data.UserName,data.CompanyCode)
       })
      }else{
        alert("请输入正确的手机号")
      }
    },
    fashong(a,e,v,d){
      let b = `token=${a}&tempToken=${e}&UserName=${v}&CompanyCode=${d}`
      axios.post('https://apiv2.zolerp.cn//api/User/SendVerfiyCodeRegister',b).then(response => {       
          console.log( response.data.Message)
          this.cashou=response.data.Message
          this.TempToken = response.data.Data.tempToken
          this.getCode()
          this.daojis=false
       })
    },

    xianshi() {
      this.cashou=""
      this.daojis = true;
      this.xinxi.CorporateName="";
      this.xinxi.Phone="";
      this.xinxi.Address="";
      this.xinxi.Contacts="";
      this.xinxi.VerificationCcode="";
      this.xianshia = !this.xianshia;
    },
    saveProduct(xinxi){
      // console.log(xinxi);
      xinxi.TempToken = this.TempToken
      var jsData1 = `CorporateName=${xinxi.CorporateName}&Phone=${xinxi.Phone}&Address=${xinxi.Address}&Contacts=${xinxi.Contacts}&VerificationCcode=${xinxi.VerificationCcode}&TempToken=${xinxi.TempToken}`;
      // console.log(jsData1);
        axios.post('https://adminapiv2.zolerp.cn//api/Examine/IntentionalCustomerAdd',jsData1).then(response => {       
          // console.log(response)
          if(this.TempToken){
          alert(response.data.Message);
            this.xianshia = false;
          }else{
          alert(response.data.Message);

          }
       })
    },
    

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.Products{
  margin-top: 70px;
}
.tanchu {
  width: 290px;
  height: 450px;
  background-color: #ffffff;
  border: 1px solid #3366ff;
  position: fixed;
  right: 34px;
  bottom: 34px;
  // bottom: -400px;

  h3 {
    background-color: #3366ff;
    margin: 0px;
    height: 50px;
    width: 290px;
    line-height: 50px;
    font-size: 16px;
    color: #ffffff;
    padding-left: 25px;
    i {
      position: absolute;
      right: 30px;
      top: 17px;
    }
  }
  .span1 {
    position: absolute;
    color: red;
    font-size: 16px;
    top: 80px;
    left: 32px;
  }
  .a1 {
    position: absolute;
    top: 140px;
    left: 32px;
  }
  .a2 {
    position: absolute;
    top: 200px;
    left: 32px;
  }
  .a3 {
    position: absolute;
    top: 260px;
    left: 32px;
  }
  .a4 {
    position: absolute;
    top: 320px;
    left: 32px;
  }
  input {
    width: 240px;
    height: 44px;
    margin-left: 22px;
    margin-top: 16px;
    padding-left: 23px;
    border: 1px solid #e5e5e5;
    font-size: 14px;
    color: #999999;
    &:hover,
    &:active,
    &:focus{
      outline: 0;
      border-radius: 10px;
      border: 1px #0066cc solid;
      // outline:medium;
    }
  }
  button {
    width: 240px;
    height: 44px;
    border: 0px;
    line-height: 44px;
    text-align: center;
    margin-top: 0px;
    margin-left: 25px;
    background-color: #3366ff;
    color: #fffefe;

    &:focus{
      outline: medium;
    }
  }
  
  .yabzeng {
    width: 140px;
  }
  .huqv {
    width: 90px;
    height: 44px;
    margin-left: 4px;
    padding-left: 2px;
    background-color: #3366ff;
    color: #fffefe;
  }
}

.v-enter {
  opacity: 0;
  bottom: -400px;
}

.v-enter-active {
  transition: all 1s linear;
}
.v-leave-active {
  transition: all 1s linear;
}

.v-leave-to {
  opacity: 0;
  bottom: -400px;
}
.wai {
  width: 100%;
  .sectiontu {
    width: 100%;
    img {
      width: 100%;
    }
  }
  .sectioncp {
    height: 755px;
    width: 1018px;
    margin: 0px auto;
    // border: 1px solid red;
    h2 {
      margin-top: 63px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    p {
      font-size: 16px;
      color: #666666;
      margin-top: 16px;
      text-align: center;
    }
    div {
      width: 100%;
      height: 554px;
      img {
        width: 100%;
      }
    }
  }
  .sectionqy {
    width: 100%;
    height: 700px;
    background-color: #f3f6ff;
    padding-top: 66px;
    // padding-bottom: 45px;
    h2 {
      // margin-top: 66px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    div {
      width: 1076px;
      height: 450px;
      margin: 0px auto;
      margin-top: 45px;
    }
  }
  .sectionhy {
    height: 2505px;
    width: 1100px;
    margin: 0px auto;
    // border: 1px solid red;
    .sectionhy1 {
      width: 1100px;
      height: 440px;
      margin: 0px auto;
      margin-top: 76px;
      img {
        width: 100%;
      }
    }
    h2 {
      margin-top: 155px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    p {
      font-size: 16px;
      color: #666666;
      margin-top: 16px;
      text-align: center;
    }
    .sectionhy2 {
      width: 1076px;
      height: 470px;
      margin: 0px auto;
      margin-top: 45px;
      img {
        width: 100%;
      }
    }
    .sectionhy3 {
      width: 1076px;
      height: 470px;
      margin: 0px auto;
      margin-top: 114px;
      img {
        width: 100%;
      }
    }
    .sectionhy4 {
      width: 1076px;
      height: 470px;
      margin: 0px auto;
      margin-top: 70px;
      img {
        width: 100%;
      }
    }
  }
  .section2b {
    width: 100%;
    background-color: #f3f6ff;
    height: 730px;
    padding-top: 66px;
    h2 {
      // margin-top: 155px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    .section2b1 {
      width: 1100px;
      height: 502px;
      margin: 0px auto;
      margin-top: 50px;
      img {
        width: 100%;
      }
    }
  }
}
.wai2 {
  width: 100%;
  .sectiontu {
    margin-top: 80px;
    width: 100%;
    height: 420px;
    margin: 0px auto;
    background: url("../assets/image/banner3.png") no-repeat 1px 1px;
    .sectiontu1 {
      padding-top: 96px;
      height: 420px;
      width: 1018px;
      margin: 0px auto;
      // border: 1px solid red;
      h2 {
        color: #ffffff;
        font-size: 40px;
        margin-bottom: 30px;
      }
      .p1 {
        color: #ffffff;
        font-size: 16px;
        margin-bottom: 13px;
      }
      .p2 {
        color: #ffffff;
        font-size: 16px;
        margin-bottom: 40px;
      }
      button {
        font-size: 18px;
        width: 160px;
        height: 40px;
        color: #ffffff;
        border: 0px;
        background-color: #20bdff; 
        transition: background 2s;
        &:focus {
          outline: medium;
        }
      }
      button:hover{
   background-color: #0084ffef;
}
    }
  }
  .sectioncp {
    height: 700px;
    width: 1080px;
    margin: 0px auto;
    // border: 1px solid red;
    h2 {
      margin-top: 60px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    div {
      margin-top: 45px;
      width: 100%;
      height: 560px;
      // border: 1px solid red;
      img {
        width: 100%;
      }
    }
  }
  .sectioncp2 {
    height: 526px;
    width: 1056px;
    margin: 0px auto;
    // border: 1px solid red;
    h2 {
      // margin-top: 63px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    p {
      font-size: 16px;
      color: #666666;
      margin-top: 16px;
      text-align: center;
    }
    div {
      width: 100%;
      height: 378px;
      img {
        width: 100%;
      }
    }
  }

  .sectiontab {
    width: 100%;
    height: 720px;
    background: url("../assets/image/kehubg.png") no-repeat 0px 0px;
    padding-top: 57px;
    h2 {
      // margin-top: 63px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    .tablan {
      width: 1100px;
      margin: 0px auto;
      margin-top: 51px;
      margin-bottom: 50px;
      height: 40px;
      border-bottom: 2px solid #b2c1ee;
      .tablan2 {
        // border: 1px solid red;
        width: 790px;
        height: 40px;
        margin: 0px auto;
        a {
          cursor: pointer;
          color: #333333;
        }
        span {
          display: inline-block;
          text-align: center;
          height: 40px;
          width: 262px;
        }
        .active {
          border-bottom: 4px solid #3366ff;
        }
      }
    }
    .tablan1 {
      width: 1002px;
      height: 370px;
      margin: 0px auto;
      img {
        width: 100%;
      }
    }
    .tablan2 {
      width: 1002px;
      height: 370px;
      margin: 0px auto;
      img {
        width: 100%;
      }
    }
    .tablan3 {
      width: 1002px;
      height: 370px;
      margin: 0px auto;
      img {
        width: 100%;
      }
    }
  }
  .sectionguanli {
    width: 1080px;
    height: 1050px;
    margin: 0px auto;
    h2 {
      margin-top: 72px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    p {
      font-size: 16px;
      color: #666666;
      margin-top: 16px;
      text-align: center;
    }
    .div1 {
      width: 100%;
      height: 380px;
      margin-bottom: 50px;
      img {
        width: 100%;
      }
    }
    .div2 {
      margin-top: 55px;
      width: 100%;
      height: 465px;
      img {
        width: 100%;
      }
    }
  }
  .sectionj {
    width: 100%;
    height: 610px;
    background-color: #fbfbfb;
    .sectionjy {
      height: 610px;
      width: 1016px;
      margin: 0px auto;
      padding-top: 20px;
      // border: 1px solid red;
      h2 {
        margin-top: 52px;
        text-align: center;
        font-size: 32px;
        color: #333333;
      }
      p {
        font-size: 16px;
        color: #666666;
        margin-top: 16px;
        text-align: center;
      }
      div {
        width: 1016px;
        height: 400px;
        img {
          width: 100%;
        }
      }
    }
  }
  .sectionyx {
    height: 526px;
    width: 1000px;
    margin: 0px auto;
    // border: 1px solid red;
    margin-bottom: 80px;
    h2 {
      margin-top: 73px;
      text-align: center;
      font-size: 32px;
      color: #333333;
    }
    p {
      font-size: 16px;
      color: #666666;
      margin-top: 16px;
      text-align: center;
    }
    div {
      margin-top: 42px;
      width: 100%;
      height: 340px;
      img {
        width: 100%;
      }
    }
  }
}
</style>